export const esSheetColumns = {
  'Abyss Fabric Component ID': 'risk_equipment_tag',
  'Level 1 Component': 'risk_level_1_component',
  'Level 2 Sub-Component': 'risk_level_2_component',
  'Facility/Dock/Berth': 'risk_dock',
  Structure: 'risk_structure',
  Component: 'risk_component_type',
  'Service Code': 'code',
  'Service Group': 'group',
  Member: 'risk_member_id',
  Elevation: 'risk_elevation',
  Sizing: 'risk_sizing',
  'Material Type': 'risk_material_type',
  'Damage Class': 'risk_damage_class',
  'Damage Class Description': 'risk_damage_class_description',
  'Inspection Method': 'risk_inspection_method',
  'EDD Method': 'risk_edd_method',
  'Governing Damage Media': 'risk_governing_damage_media',
  'Inspection Date': 'risk_inspection_date',
  'Defect Codes': 'risk_defect_codes',
  'Damage Mechanism Metric': 'risk_damage_mechanism_metric',
  'Damage Mechanism Size': 'risk_damage_mechanism_size',
  'Subsea Cathodic Protection': 'risk_subsea_cathodic_protection',
  'Subsea Ultrasonic Testing': 'risk_subsea_ultrasonic_testing',
  'Subsea General Visual Inspection': 'risk_subsea_general_visual_inspection',
  'Additional Remarks': 'risk_additional_remarks',
  'Task Description': 'risk_task_description',
  'Task Frequency': 'risk_task_frequency',
  'Task Responsibility': 'risk_task_responsibility',
};

export const serviceKeys = new Set(['code', 'group']);

export const ES_MAPPING_KEYS = [
  {
    name: 'Equipment Tag',
    required: true,
    key: 'risk_equipment_tag',
  },
  {
    name: 'Old Equipment Tag',
    required: false,
    key: 'risk_old_equipment_tag',
  },
  {
    name: 'Level 1 Component',
    required: true,
    key: 'risk_level_1_component',
  },
  {
    name: 'Level 2 Component',
    required: true,
    key: 'risk_level_2_component',
  },
  {
    name: 'Dock',
    required: true,
    key: 'risk_dock',
  },
  {
    name: 'Structure',
    required: true,
    key: 'risk_structure',
  },
  {
    name: 'Component Type',
    required: true,
    key: 'risk_component_type',
  },
  {
    name: 'Member Id',
    required: false,
    key: 'risk_member_id',
  },
  {
    name: 'Material Type',
    required: true,
    key: 'risk_material_type',
  },
  {
    name: 'Damage Class',
    required: true,
    key: 'risk_damage_class',
  },
  {
    name: 'Elevation',
    required: true,
    key: 'risk_elevation',
  },
  {
    name: 'Sizing',
    required: true,
    key: 'risk_sizing',
  },
  {
    name: 'EDD Method',
    required: true,
    key: 'risk_edd_method',
  },
  {
    name: 'Task Description 1',
    required: false,
    key: 'risk_task_description_1',
  },
  {
    name: 'Task Description 2',
    required: false,
    key: 'risk_task_description_2',
  },
  {
    name: 'Task Description 3',
    required: false,
    key: 'risk_task_description_3',
  },
  {
    name: 'Task Description 4',
    required: false,
    key: 'risk_task_description_4',
  },
  {
    name: 'Task Frequency 1',
    required: false,
    key: 'risk_task_frequency_1',
  },
  {
    name: 'Task Frequency 2',
    required: false,
    key: 'risk_task_frequency_2',
  },
  {
    name: 'Task Frequency 3',
    required: false,
    key: 'risk_task_frequency_3',
  },
  {
    name: 'Task Frequency 4',
    required: false,
    key: 'risk_task_frequency_4',
  },
  {
    name: 'Task Responsibility 1',
    required: false,
    key: 'risk_task_responsibility_1',
  },
  {
    name: 'Task Responsibility 2',
    required: false,
    key: 'risk_task_responsibility_2',
  },
  {
    name: 'Task Responsibility 3',
    required: false,
    key: 'risk_task_responsibility_3',
  },
  {
    name: 'Task Responsibility 4',
    required: false,
    key: 'risk_task_responsibility_4',
  },
  {
    name: 'Base POF Value',
    required: true,
    key: 'risk_base_pof_value',
  },
  {
    name: 'Safety (POF)',
    required: true,
    key: 'risk_safety_calculated_value_pof',
  },
  {
    name: 'Environment (POF)',
    required: true,
    key: 'risk_environment_calculated_value_pof',
  },
  {
    name: 'Public Impact (POF)',
    required: true,
    key: 'risk_public_impact_calculated_value_pof',
  },
  {
    name: 'Direct Cost (POF)',
    required: true,
    key: 'risk_direct_cost_calculated_value_pof',
  },
  {
    name: 'Business Loss (POF)',
    required: true,
    key: 'risk_business_loss_calculated_value_pof',
  },
  {
    name: 'Safety (COF)',
    required: true,
    key: 'risk_safety_cof',
  },
  {
    name: 'Environment (COF)',
    required: true,
    key: 'risk_environment_cof',
  },
  {
    name: 'Public Impact (COF)',
    required: true,
    key: 'risk_public_impact_cof',
  },
  {
    name: 'Direct Cost (COF)',
    required: true,
    key: 'risk_direct_cost_cof',
  },
  {
    name: 'Business Loss (COF)',
    required: true,
    key: 'risk_business_loss_cof',
  },
  {
    name: 'Transition Period',
    required: true,
    key: 'risk_transition_period',
  },
  {
    name: 'Safety Actual Value Pof',
    required: true,
    key: 'risk_safety_actual_value_pof',
  },
  {
    name: 'Environment Actual Value Pof',
    required: true,
    key: 'risk_environment_actual_value_pof',
  },
  {
    name: 'Public Impact Actual Value Pof',
    required: true,
    key: 'risk_public_impact_actual_value_pof',
  },
  {
    name: 'Direct Cost Actual Value Pof',
    required: true,
    key: 'risk_direct_cost_actual_value_pof',
  },
  {
    name: 'Business Loss Actual Value Pof',
    required: true,
    key: 'risk_business_loss_actual_value_pof',
  },
  {
    name: 'Coating System',
    required: false,
    key: 'risk_coating_system',
  },
  {
    name: 'Corrosivity Category',
    required: true,
    key: 'risk_corrosivity_category',
  },
  {
    name: 'Built Year',
    required: false,
    key: 'risk_built_year',
  },
  {
    name: 'Inspection Year',
    required: false,
    key: 'risk_inspection_year',
  },
  {
    name: 'Unmitigated Safety',
    required: true,
    key: 'risk_unmitigated_safety',
  },
  {
    name: 'Unmitigated Environment',
    required: true,
    key: 'risk_unmitigated_environment',
  },
  {
    name: 'Unmitigated Public Impact',
    required: true,
    key: 'risk_unmitigated_public_impact',
  },
  {
    name: 'Unmitigated Direct Cost',
    required: true,
    key: 'risk_unmitigated_direct_cost',
  },
  {
    name: 'Governing Financials',
    required: true,
    key: 'risk_unmitigated_business_loss',
  },
  {
    name: 'Governing SHE ISO Risk',
    required: true,
    key: 'risk_unmitigated_she_calculated_value',
  },
  {
    name: 'Governing SHE',
    required: true,
    key: 'risk_unmitigated_she_actual_value',
  },
  {
    name: 'Thickness',
    required: false,
    key: 'risk_thickness',
  },
  {
    name: 'Safety P1 (POF)',
    required: false,
    key: 'risk_safety_value_pof_p1',
  },
  {
    name: 'Safety P2 (POF)',
    required: false,
    key: 'risk_safety_value_pof_p2',
  },
  {
    name: 'Environment P1 (POF)',
    required: false,
    key: 'risk_environment_value_pof_p1',
  },
  {
    name: 'Environment P2 (POF)',
    required: false,
    key: 'risk_environment_value_pof_p2',
  },
  {
    name: 'Public Impact P1 (POF)',
    required: false,
    key: 'risk_public_impact_value_pof_p1',
  },
  {
    name: 'Public Impact P2 (POF)',
    required: false,
    key: 'risk_public_impact_value_pof_p2',
  },
  {
    name: 'Direct Cost P1 (POF)',
    required: false,
    key: 'risk_direct_cost_value_pof_p1',
  },
  {
    name: 'Direct Cost P2 (POF)',
    required: false,
    key: 'risk_direct_cost_value_pof_p2',
  },
  {
    name: 'Business Loss P1 (POF)',
    required: false,
    key: 'risk_business_loss_value_pof_p1',
  },
  {
    name: 'Business Loss P2 (POF)',
    required: false,
    key: 'risk_business_loss_value_pof_p2',
  },
  {
    name: 'Safety (C)',
    required: false,
    key: 'risk_safety_value_pof_c',
  },
  {
    name: 'Environment (C)',
    required: false,
    key: 'risk_environment_value_pof_c',
  },
  {
    name: 'Public Impact (C)',
    required: false,
    key: 'risk_public_impact_value_pof_c',
  },
  {
    name: 'Direct Cost (C)',
    required: false,
    key: 'risk_direct_cost_value_pof_c',
  },
  {
    name: 'Business Loss (C)',
    required: false,
    key: 'risk_business_loss_value_pof_c',
  },
  {
    name: 'Description',
    required: false,
    key: 'risk_description',
  },
  {
    name: 'Transition Date 1',
    required: true,
    key: 'risk_transition_date_1',
  },
  {
    name: 'Transition Date 2',
    required: false,
    key: 'risk_transition_date_2',
  },
  {
    name: 'Transition Date 3',
    required: false,
    key: 'risk_transition_date_3',
  },
  {
    name: 'Transition Date 4',
    required: false,
    key: 'risk_transition_date_4',
  },
  {
    name: 'Transition Date 5',
    required: false,
    key: 'risk_transition_date_5',
  },
  {
    name: 'Governing SHE RC',
    required: false,
    key: 'risk_unmitigated_she_category',
  },
  {
    name: 'Governing Financial RC',
    required: false,
    key: 'risk_unmitigated_financials_category',
  },
  { name: 'Utilization Ratio', required: false, key: 'risk_utilization_ratio' },
];
